module.exports = "pegasus/assets/column-10-basic.png";